var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdleAccounts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00354 3.33311C7.00354 3.17311 7.00354 3.09377 7.05687 3.04444C7.11154 2.99511 7.18621 3.00111 7.33687 3.01377C8.00845 3.06987 8.65497 3.29473 9.21641 3.66748C9.77786 4.04024 10.236 4.5488 10.5484 5.14596C10.8607 5.74313 11.0171 6.40953 11.0031 7.0833C10.989 7.75707 10.805 8.41637 10.468 8.99999C10.131 9.58361 9.65205 10.0726 9.07556 10.4217C8.49906 10.7707 7.84373 10.9684 7.1704 10.9964C6.49706 11.0245 5.82756 10.8819 5.22404 10.5821C4.62052 10.2822 4.10254 9.83469 3.71821 9.28111C3.63154 9.15711 3.58887 9.09511 3.60487 9.02377C3.62087 8.95244 3.69021 8.91311 3.82821 8.83311L6.83687 7.09577C6.91821 7.04911 6.95887 7.02577 6.98087 6.98711C7.00354 6.94844 7.00354 6.90111 7.00354 6.80711V3.33311Z",
    fill: "#6B6B6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 13C10.3137 13 13 10.3137 13 7C13 3.68629 10.3137 1 7 1C3.68629 1 1 3.68629 1 7C1 10.3137 3.68629 13 7 13Z",
    stroke: "#6B6B6B",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdleAccounts);
export default __webpack_public_path__ + "static/media/idle-accounts.ccf13c1fcf3f225a482196a8c6d6f54e.svg";
export { ForwardRef as ReactComponent };